import React from "react";
import { AlertTriangle, RefreshCw, CheckCircle, Tool, Circle } from "react-feather";
import { DIAGNOSIS_CONDITION_LABEL, DIAGNOSIS_CONDITION_CLASS } from "../technicalStatusMaps";
import { MAROON } from "../../../components/common/brandColors";

// The technician's fault findings, READ-ONLY.
//
// Each row is recorded on site against a product the technician scanned
// (Stock's "PRD:{branchId}:{productCode}" QR), so adding one is a field
// activity and is deliberately not offered here - but the findings are a
// central part of what a manager verifies before closing, so they get the
// full card treatment rather than a bare list.
const CONDITION_ICON = {
  FAULTY: AlertTriangle,
  NEEDS_REPLACEMENT: RefreshCw,
  REPAIRED: CheckCircle,
  NEEDS_SERVICE: Tool,
};

const CONDITION_COLOR = {
  FAULTY: "#DC3545",
  NEEDS_REPLACEMENT: "#FD7E14",
  REPAIRED: "#1E7E34",
  NEEDS_SERVICE: "#0D6EFD",
};

const formatDateTime = (iso) =>
  iso
    ? new Date(iso).toLocaleString(undefined, {
        day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "2-digit",
      })
    : "-";

const DiagnosisPanel = ({ diagnoses = [] }) => {
  if (diagnoses.length === 0) {
    return <p className="text-muted mb-0">No fault findings recorded.</p>;
  }

  return (
    <>
      {diagnoses.map((d) => {
        const Icon = CONDITION_ICON[d.condition] || Circle;
        const color = CONDITION_COLOR[d.condition] || MAROON;
        return (
          <div
            key={d.recordGuid}
            className="d-flex p-2 mb-2 rounded"
            style={{ border: `1px solid ${color}33`, background: `${color}0A` }}
          >
            <span
              className="d-inline-flex align-items-center justify-content-center rounded-circle me-2 flex-shrink-0"
              style={{ width: 30, height: 30, background: `${color}1F`, color }}
            >
              <Icon size={16} />
            </span>
            <div className="flex-grow-1 min-width-0">
              <div className="d-flex justify-content-between align-items-start">
                <span className="fw-semibold" style={{ fontSize: 13.5 }}>
                  {d.productName || `Product ${d.productCode}`}
                </span>
                <span className={`badge ms-2 flex-shrink-0 ${DIAGNOSIS_CONDITION_CLASS[d.condition] || "badge-linesecondary"}`}>
                  {DIAGNOSIS_CONDITION_LABEL[d.condition] || d.condition}
                </span>
              </div>
              {d.diagnosisRemarks && <div style={{ fontSize: 13 }}>{d.diagnosisRemarks}</div>}
              {/* Muted, small, italic audit footer - house style for
                  who-did-this-and-when lines. */}
              <div className="text-muted fst-italic" style={{ fontSize: 11 }}>
                Added by {d.createdByName || "-"} on {formatDateTime(d.createdDate)}
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default DiagnosisPanel;
